import React from 'react'
import Constant from '../Constant'
import axios from 'axios'
import Swal from 'sweetalert2'
// import Charts from './Charts/charts'
import moment from 'moment'
// import Button from './CustomComponents/Button'

class AdminDashboard extends React.Component {
  state = {
    total_boats: 0,
    captain: 0,
    orders: 0,
    activity: 0,
    total_earning: 0,
    total_commission: 0,
    today_earningwithcoupon: 0,
    total_earningwithcoupon: 0,
    today_commission: 0,
    today_orders: 0,
    event_ticket_purchashed: 0,
    event_total_sales: 0,
    fnb_sales_today: 0,
    fnb_total_orders: 0,
    fnb_total_sales: 0,
    countryList: [],

    selected_booking_type: 'CRUISE',
    board_type: 'NUMBERS',
    date_from: moment().add(-1, 'M').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),

    tamaraKWT: {
      min: 0,
      max: 0,
    },
    tamaraQAT: {
      min: 0,
      max: 0,
    },
    tamaraKSA: {
      min: 0,
      max: 0,
    },
    tamaraUAE: {
      min: 0,
      max: 0,
    },
  }

  // Create a ref for the child component
  chartComponent = React.createRef()

  componentDidMount() {
    this.dashbord()
    this.countryList()
  }

  countryList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + '/auth/list-countries?show_all_countries=true', {
        headers: {
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            countryList: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSelectChange = (event) => {
    localStorage.setItem('countryShortName', event.target.value)
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  dashbord = async () => {
    var that = this
    var selectedCountry = localStorage.getItem('countryShortName')
    var country = selectedCountry && selectedCountry !== 'null' ? selectedCountry : 'KWT'
    localStorage.setItem('countryShortName', country)
    await axios
      .get(Constant.getAPI() + '/user/dashboard', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: country,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            total_boats: res?.data?.data?.total_boats,
            orders: res?.data?.data?.total_orders,
            total_commission: res?.data?.data?.total_commission,
            total_earning: res?.data?.data?.total_earning,
            Data: res?.data?.data?.role_counts,
            today_orders: res?.data?.data?.today_orders,
            today_earningwithcoupon: res?.data?.data?.today_earningwithcoupon,
            total_earningwithcoupon: res?.data?.data?.total_earningwithcoupon,
            today_commission: res?.data?.data?.today_commission,
            event_ticket_purchashed: res?.data?.data?.event_ticket_purchashed,
            event_total_sales: res?.data?.data?.event_total_sales,
            fnb_sales_today: res?.data?.data?.fnb_sales_today,
            fnb_total_orders: res?.data?.data?.fnb_total_orders,
            fnb_total_sales: res?.data?.data?.fnb_total_sales,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    })
  }

  updateFilters = () => {
    if (this.chartComponent.current) {
      this.chartComponent.current.search()
    }
  }

  render() {
    var showSelectedCountry = localStorage.getItem('countryShortName')

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div
            className="page-header p-b-10 m-b-10"
            style={{ borderBottom: '1px solid #ddd' }}
          >
            <div className="row align-items-end">
              <div className="col-9">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Dashboard</h4>
                  </div>
                </div>
              </div>

              <div
                className="col-3 f-right"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                }}
              >
                <select
                  name="country_name"
                  className="form-control"
                  onChange={this.onSelectChange}
                  value={this.state.country_name || showSelectedCountry || 'KWT'}
                >
                  {this.state?.countryList && this.state?.countryList?.length > 0
                    ? this.state.countryList?.map((itm, i) => (
                        <option
                          value={itm?.country_short_name}
                          key={i}
                        >
                          {itm?.country_name}
                        </option>
                      ))
                    : null}
                </select>
              </div>
            </div>
          </div>
          <div className="page-body">
            {/* <div className="row m-b-10 align-items-end">
              <div className="col-3 m-b-5">
                <label>Board Type</label>
                <select
                  value={this.state.board_type}
                  name="board_type"
                  className="form-control"
                  onChange={this.handleChange}
                >
                  <option value={'NUMBERS'}>Numbers</option>
                  <option value={'CHARTS'}>Charts</option>
                </select>
              </div>
              {this.state.board_type == 'CHARTS' && (
                <>
                  <div className="col-3 m-b-5">
                    <label>Booking Type</label>
                    <select
                      value={this.state.selected_booking_type}
                      name="selected_booking_type"
                      className="form-control"
                      onChange={this.handleChange}
                    >
                      <option value={'CRUISE'}>Cruise</option>
                      <option value={'CHALET'}>Chalet</option>
                      <option value={'STORE'}>Store</option>
                      <option value={'EVENT'}>Event</option>
                    </select>
                  </div>
                  <div className="col-3 m-b-5">
                    <label>Date From</label>
                    <input
                      type="date"
                      id="date_from"
                      className="form-control"
                      value={this.state.date_from}
                      name="date_from"
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-3 m-b-5">
                    <label>Date To</label>
                    <input
                      type="date"
                      id="date_to"
                      className="form-control"
                      value={this.state.date_to}
                      name="date_to"
                      onChange={this.handleChange}
                    />
                  </div>
                </>
              )}
              <div className="col-3">
                <Button onClick={this.updateFilters}>Apply</Button>
              </div>
            </div> */}
            {this.state.board_type == 'CHARTS' ? (
              <div className="row">
                <div className="col-12">
                  {/* <Charts
                    ref={this.chartComponent}
                    board_type={this.state.board_type}
                    date_from={this.state.date_from}
                    date_to={this.state.date_to}
                    booking_type={this.state.selected_booking_type}
                  ></Charts> */}
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state.total_earning?.toFixed(2)}</h4>
                          <h6 className="text-muted m-b-0">Total Earning</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-yellow f-w-600">{this.state.total_commission?.toFixed(2)}</h4>
                          <h6 className="text-muted m-b-0">Total Commission</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-hotel-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-yellow"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-green f-w-600">{this.state.total_boats}</h4>
                          <h6 className="text-muted m-b-0">Total Boats</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i
                            style={{ fontSize: '28px' }}
                            className="icofont icofont-sail-boat-alt-1"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-green"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-orenge f-w-600">{this.state.today_orders}</h4>
                          <h6 className="text-muted m-b-0">Today Orders</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-orenge"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state.orders}</h4>
                          <h6 className="text-muted m-b-0">Total Orders</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-green f-w-600">{this.state.today_commission?.toFixed(2)}</h4>
                          <h6 className="text-muted m-b-0">Today Commission</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i
                            style={{ fontSize: '28px' }}
                            className="icofont icofont-sail-boat-alt-1"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-green"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state.total_earningwithcoupon?.toFixed(2)}</h4>
                          <h6 className="text-muted m-b-0">Total Earning Coupon</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-yellow f-w-600">
                            {this.state.Data?.[0]?.count ? this.state.Data?.[0]?.count : '0'}
                          </h4>
                          <h6 className="text-muted m-b-0">
                            Total{' '}
                            {this.state.Data?.[0]?.user_type === 'admin'
                              ? 'Boat Owner'
                              : this.state.Data?.[0]?.user_type}
                          </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-yellow"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state?.today_earningwithcoupon?.toFixed(2)}</h4>
                          <h6 className="text-muted m-b-0">Today Earning Coupon</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-orenge f-w-600">
                            {this.state.Data?.[1]?.count ? this.state.Data?.[1]?.count : '0'}
                          </h4>
                          <h6 className="text-muted m-b-0">
                            Total{' '}
                            {this.state.Data?.[1]?.user_type === 'admin'
                              ? 'Boat Owner'
                              : this.state.Data?.[1]?.user_type}
                          </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-orenge"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-yellow f-w-600">
                            {this.state.Data?.[2]?.count ? this.state.Data?.[2]?.count : '0'}
                          </h4>
                          <h6 className="text-muted m-b-0">
                            Total{' '}
                            {this.state.Data?.[2]?.user_type === 'admin'
                              ? 'Boat Owner'
                              : this.state.Data?.[2]?.user_type}
                          </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-green"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-orenge f-w-600">
                            {this.state.Data?.[3]?.count ? this.state.Data?.[3]?.count : '0'}
                          </h4>
                          <h6 className="text-muted m-b-0">
                            Total{' '}
                            {this.state.Data?.[3]?.user_type === 'admin'
                              ? 'Boat Owner'
                              : this.state.Data?.[3]?.user_type}
                          </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-orenge"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-green f-w-600">
                            {this.state.Data?.[5]?.count ? this.state.Data?.[5]?.count : '0'}
                          </h4>
                          <h6 className="text-muted m-b-0">
                            Total{' '}
                            {this.state.Data?.[5]?.user_type === 'admin'
                              ? 'Boat Owner'
                              : this.state.Data?.[5]?.user_type}
                          </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-green"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">
                            {this.state.Data?.[4]?.count ? this.state.Data?.[4]?.count : '0'}
                          </h4>
                          <h6 className="text-muted m-b-0">
                            Total{' '}
                            {this.state.Data?.[4]?.user_type === 'admin'
                              ? 'Boat Owner'
                              : this.state.Data?.[4]?.user_type}
                          </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state.event_ticket_purchashed}</h4>
                          <h6 className="text-muted m-b-0">Event Ticket Purchashed </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-yellow"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-green f-w-600">{this.state.event_total_sales}</h4>
                          <h6 className="text-muted m-b-0">Event Ticket Total Sales</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-green"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state.fnb_sales_today?.toFixed(2)}</h4>
                          <h6 className="text-muted m-b-0">F&b Sales Today</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-yellow f-w-600">{this.state.fnb_total_orders?.toFixed(2)}</h4>
                          <h6 className="text-muted m-b-0">F&b Total Orders</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-yellow"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state?.fnb_total_sales?.toFixed(2)}</h4>
                          <h6 className="text-muted m-b-0">F&b Total Sales</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default AdminDashboard
